export const keys = {
  localStorage: {
    educationCache: "educationCache",
    educationCacheExpiration: "educationCacheExpiration",
    eventKey: "storage",
    selectedCourse: "selectedCourse",
    language: "language",
    i18nextLng: "i18nextLng",
    hideExpiredEducationsSection: "hideExpiredEducationsSection",
    hideCertificateSection: "hideCertificateSection",
    sidebarCollapsed: "sidebarCollapsed",
    celebratedCertificates: "celebratedCertificates",
    /** Set to "true" in localStorage to show theory AI chat (debug). */
    aiChatDebug: "finanslicenser_debug_ai_chat",
    /** Preview level completion animation without saving progress to Firebase. */
    levelCompletionAnimationDebug: "finanslicenser_debug_level_completion_animation",
    /** Multiplier for level completion + modal fly-back timings (dev). */
    completionAnimationSlowMotion: "finanslicenser_debug_completion_slow_motion",
  }
};